import React from 'react';
import { Box, Typography } from '@mui/material';
import { departmentColor, departmentInitials } from '../departments';
import { displayText } from '../helpers';
import { launchColors } from '../launchTheme';

interface Props {
  name: string;
  size?: number;
  nameSize?: number;
}

const DepartmentBadge: React.FC<Props> = ({ name, size = 28, nameSize = 13 }) => {
  const label = displayText(name);
  if (!label) {
    return <Typography sx={{ fontSize: nameSize, color: launchColors.textSecondary }}>Avdelning saknas</Typography>;
  }
  const color = departmentColor(name);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }} title={label}>
      <Box
        aria-hidden
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          flexShrink: 0,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: Math.max(10, Math.round(size * 0.38)),
          fontWeight: 700,
          lineHeight: 1,
          color: color.fg,
          bgcolor: color.bg,
        }}
      >
        {departmentInitials(name)}
      </Box>
      <Typography noWrap sx={{ fontSize: nameSize, fontWeight: 600, color: launchColors.text, lineHeight: 1.3 }}>{label}</Typography>
    </Box>
  );
};

export default DepartmentBadge;
